<div style="text-align: center;">
    <!-- <img src="../../../../assets/images/warningIllustration.svg" alt=""
        style="display: flex; width: 400px; padding: 30px 0px;    margin: auto;"> -->
    <mat-card-title style="color: #1A47D6; margin-bottom: 40px;margin-top: 60px;">Welcome to TLS Ensure</mat-card-title>
    <p>In order to get started, please first update your DNS records to work with StayPrivate. <br><br> You will find instructions how to do this in the <a style="cursor: pointer;" (click)="nav()">DNS Setup</a> tab. <br><br></p>
    <div>
        
        <button mat-stroked-button style="color: #1A47D6; border-color: #1A47D6; margin:20px auto 20px auto; width: 25%;" (click)="cancel()">
            Close
        </button>
    </div>

</div>